import { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { push as pushHistory } from 'react-router-redux'

import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import Button from '@mui/material/Button'

import { AdminHeaderLogoIcon, AdminLogoutIcon } from 'icons'
import * as Routes from 'constants/Routes'
import styles from './MainLayout.module.scss'

export class MainLayout extends PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
    pushHistory: PropTypes.func.isRequired
  }

  redirectTo = route => {
    this.props.pushHistory(route)
  }

  handleNavItemClick = route => () => {
    this.redirectTo(route)
  }

  render() {
    const { children } = this.props

    return (
      <div className={styles.root}>
        <AppBar
          position='absolute'
          elevation={0}
          className={styles.appBar}
        >
          <Toolbar
            disableGutters
            className={styles.toolbar}
          >
            <div className={styles.brand}>
              <img
                className={styles.logo}
                src={AdminHeaderLogoIcon}
                alt=''
                onClick={this.handleNavItemClick(Routes.MAIN)}
                style={{ cursor: 'pointer' }}
              />
              <span className={styles.title}>DASHBOARD ADMIN</span>
            </div>

            <Button
              classes={{
                root: styles.logoutButton,
                label: styles.logoutButtonLabel
              }}
              onClick={this.handleNavItemClick(Routes.LOGOUT)}
            >
              <img
                className={styles.logoutIcon}
                src={AdminLogoutIcon}
                alt='Cerrar sesión'
              />
            </Button>
          </Toolbar>
        </AppBar>

        <main className={styles.content}>
          <div className={styles.appBarSpacer} />
          {children}
        </main>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  // Empty
})

const mapActionsToProps = {
  pushHistory
}

export default connect(mapStateToProps, mapActionsToProps)(MainLayout)
